import { render, staticRenderFns } from "./tradeAuth.vue?vue&type=template&id=571e179e&scoped=true&"
import script from "./tradeAuth.vue?vue&type=script&lang=js&"
export * from "./tradeAuth.vue?vue&type=script&lang=js&"
import style0 from "./tradeAuth.vue?vue&type=style&index=0&id=571e179e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e179e",
  null
  
)

export default component.exports